import { list as _list, listAll as _listAll } from './actions'
import store from '@/store'

/**
 *  Преобразование параметров в данные колонки
 * @param {Object} p
 */
export function paramToColumn(p) {
  return {
    id: 'custom_' + p.id,
    slug: p.slug,
    value: p.id,
    text: p.name,
    type: p.type,
    custom: true,
    sortable: p.sortable,
    filterable: p.filterable,
    values: p.values || []
  }
}

/**
 * List of custom params
 * @param {Object} requestData
 */
export function list(binded = false) {
  let postId = store.getters['app/account/getPostId']
  return _list(postId, binded)
}

/**
 * Get all parameters
 * @returns {Promise}
 */
export function listAll() {
  let postId = store.getters['app/account/getPostId']
  return _listAll(postId)
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/api/parameters/index.js